import React from "react";
import icon from "../../../assets/images/calendar.png";

// To customize the input textbox of the React Datepicker component
class CustomDatePickerInput extends React.Component {
  render() {
    let styles = {
      background: "white url(" + icon + ") no-repeat 95% center",
      backgroundSize: "20px"
    };

    return <input type="text" value={this.props.value} style={styles} onClick={this.props.onClick} readOnly title={this.props.tooltip} />;
  }
}

export default CustomDatePickerInput;



// WEBPACK FOOTER //
// ./src/components/Common/CustomDatePickerInput/CustomDatePickerInput.js